export default function MastheadNav() {
  return (
    <nav className="flex items-center justify-between px-6 py-6 sm:px-10 sm:py-7">
      <a
        href="#top"
        className="text-[20px] text-[#2B2414] no-underline font-display"
        style={{
          fontWeight: 400,
          letterSpacing: '-0.01em',
        }}
      >
        HELIOS
      </a>

      <a
        href="#waitlist"
        className="inline-flex items-center justify-center rounded-full bg-[#9E2D1B] px-5 py-2.5 text-[14px] text-[#F2ECE0] no-underline transition-colors duration-200 hover:bg-[#8A2717] font-body"
        style={{
          fontWeight: 500,
          letterSpacing: '-0.006em',
          minHeight: 40,
        }}
      >
        Join Waitlist
      </a>
    </nav>
  );
}
